import $ from 'jquery';

const submitEmailCodeForm = function(email, callback) {
	let formData = new FormData();
	formData.append('email', email);
	$('#warning-message').hide();
	$('body').addClass('loading');
	fetch('/actions/strawberry-module/default/generate-otp-number', {
		method: 'POST',
		headers: {'accept': 'application/json'}, 
		body: formData
		}).then(res => res.json()).then(response => { 
			$('body').removeClass('loading');
			if(response.result === true) {
				if(callback === undefined) 
				{
					window.location.href = '/logginn/engangskode?email=' + email;
				} else {
					callback();
				}
			} else {
				$('#warning-message').show();
				console.log('Form error!')
			}
	}).catch((error) => {
		$('body').removeClass('loading');
		console.log(error);
	});
};

window.submitEmailCodeForm = submitEmailCodeForm;

export default () => {
	let loginForm = $('#login-form');

	$('.field input', loginForm).on('blur', function(e) {
		if($(this).val() === null || $(this).val() === "") {
			$(this).removeClass('filled');
		} else {
			$(this).addClass('filled');
		}
	});

	$('.btn-submit', loginForm).on('click', function(e) {
		e.preventDefault();
		e.stopPropagation();
		let mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
		if($('#login-email').val() != '' && $('#login-email').val().match(mailformat)) {
			submitEmailCodeForm($('#login-email').val());
		}
	});
	
};